import React from 'react'
import * as  C from "../componentsM/index"

const Sciences = () => {
    return (
        <>

            <C.Hero title={"GROUP 4: SCIENCES"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>The Group 4 subjects of the IB explore the domains of scientific knowledge as well as scientific activity.  A common curriculum model applies to all Group 4 programmes. This model offers a parallel structure at both Higher and Standard Levels, whereby a core of material is studied by all candidates, and this is supplemented by the study of options. Both HL and SL students have a choice of choosing 2 out of four options. For HL students, in addition to the common Core they study an additional AHL segment.</p>


                    <p>In order to fulfill the requirements of the programme, students are required to participate in the Group 4 project, a student-led interdisciplinary project bringing subject knowledge and skills from all three natural sciences.</p>

                    <p>Subjects currently offered:</p>

                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Biology (SL & HL):</h1>

                    <p>Biology is the study of life and an interest in life is natural for humans.  Not only are we living organisms ourselves, but we depend on many species for our survival, are threatened by some and co-exist with many more. In this subject we attempt to understand the living world at all levels ranging from the simple cell to complex ecosystem</p>


                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Chemistry (SL & HL):</h1>

                    <p>Chemistry is an experimental science that combines academic study with the acquisition of practical and investigational skills. It is often called the central science, as chemical principles underpin both the physical environment in which we live and all biological systems. Apart from being a subject worthy of study in its own right, chemistry is a prerequisite for many other courses in higher education, such as medicine, biological science and environmental science.</p>



                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Physics (SL & HL):</h1>


                    <p>Physics is the most fundamental of the experimental sciences, as it seeks to explain the universe itself from the very smallest particles to the vast distances between galaxies.</p>

                    <p>This course allows students to develop traditional practical skills and techniques and increase their abilities in the use of mathematics, which is the language of physics. It also allows students to develop interpersonal and digital communication skills which are essential in modern scientific endeavour and are important life-enhancing, transferable skills in their own right.</p>



                </div>
            </section>

        </>

    )
}

export default Sciences